import React from "react";

interface Service {
  title: string;
  description: string;
  link: string;
}

interface ServicesSectionProps {
  services: Service[];
}

const ServicesSection: React.FC<ServicesSectionProps> = ({ services }) => {
  return (
    <section className="bg-[#F9FBFC] py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl sm:text-3xl font-bold font-serif text-center sm:text-left mb-8">
          Portfólio
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <a
              key={index}
              href={service.link}
              target="_self"
              rel="noopener noreferrer"
              className="bg-[#F59220] px-6 py-6 rounded-2xl shadow-md hover:shadow-lg transition-transform hover:-translate-y-1 text-center block"
            >
              <h3 className="text-xl font-semibold text-white mb-3">
                {service.title}
              </h3>
              <p className="text-[#F7F7F7] text-sm leading-relaxed">
                {service.description}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
